import { Decimal } from "classes/DecimalClasses";

import { i18n } from "services/i18nService";

export function quantitySerialsIsValid(
  errors,
  lines,
  autoSerialLotNumbering,
  lineType = "line",
  quantityKey = "quantity"
) {
  const newErrors = { ...errors };

  lines.forEach((line) => {
    const { lineNumber, serials, itemDetails } = line;
    // if not auto-numbered, number of serial numbers must match quantity
    if (itemDetails?.serialTracking && !autoSerialLotNumbering) {
      const nonBlankSerials = serials
        ? serials.filter(({ name }) => name !== "")
        : [];

      // adjustments allow for negative quantity values
      const absoluteQuantity = line[quantityKey].abs();
      if (!new Decimal(nonBlankSerials.length).eq(absoluteQuantity)) {
        newErrors.messages.push(
          i18n("isValid.LineItem.QuantitySerialsMismatch", {
            lineNumber,
            lineType,
          })
        );
        newErrors[lineType][lineNumber].push(quantityKey, "serials");
      }
    }
  });

  return newErrors;
}
